/**
 * Environment variables and app configurations.
 *
 * Regra única e previsível:
 * - DEV: usa VITE_API_URL / VITE_API_BASE_URL se definidas; senão http://localhost:3003
 * - PROD: usa SEMPRE https://api-control.cyzor.com.br, sem exceções.
 *   Se houver variável VITE_API_URL/VITE_API_BASE_URL em produção, ela NÃO pode ser localhost.
 *   Qualquer URL localhost em build de produção gera erro explícito.
 */
const isProd = (import.meta as any).env?.PROD === true;

function resolveApiBaseUrl(): string {
  const raw = ((import.meta as any).env?.VITE_API_URL as string | undefined)
    || ((import.meta as any).env?.VITE_API_BASE_URL as string | undefined);

  if (isProd) {
    const productionUrl = 'https://api-control.cyzor.com.br';

    if (raw && raw.trim().length > 0) {
      const url = raw.trim();
      const isLocalhost = /^https?:\/\/localhost(?::\d+)?(?:\/|$)/i.test(url);
      if (isLocalhost) {
        throw new Error(
          `[ENV] Configuracao invalida: API_BASE_URL aponta para localhost (${url}) em producao. ` +
          `Use https://api-control.cyzor.com.br ou remova VITE_API_URL/VITE_API_BASE_URL do build de producao.`
        );
      }

      if (!url.startsWith('http://') && !url.startsWith('https://')) {
        throw new Error(
          `[ENV] Configuracao invalida: VITE_API_URL/VITE_API_BASE_URL deve ser uma URL absoluta (${url}).`
        );
      }

      return url;
    }

    return productionUrl;
  }

  // Desenvolvimento local
  if (raw && raw.trim().length > 0) {
    return raw.trim();
  }

  return 'http://localhost:3001';
}

export const ENV = {
  NODE_ENV: (import.meta as any).env?.MODE || 'development',
  IS_DEV: (import.meta as any).env?.DEV,
  IS_PROD: (import.meta as any).env?.PROD,
  API_BASE_URL: resolveApiBaseUrl(),
  APP_URL: window.location.origin,
  VERSION: '1.0.0-rc.1',
} as const;

export default ENV;
